import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import EventMedia from "@/components/Events/EventMedia/EventMedia.vue";
import TreeViewSelection from "@/components/Common/TreeViewSelection/TreeViewSelection.vue";
import LocationMap from "@/components/Common/LocationMap/LocationMap.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
import { getUserById } from "@/helpers/userHelper";
import moment from "moment/moment";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import "@/EditDialog.scss";
import CommentChat from "@/components/KIS/CommentChat/CommentChat.vue";
export default {
  name: "KisDefectEditDialog",
  components: {
    CommentChat,
    LogOverview,
    LocationMap,
    TreeViewSelection,
    EventMedia,
    ValidationDialog
  },
  props: ["defect", "dialog", "defectCategories", "dialog", "persons"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    step: 1,
    user: null,
    isValid: false,
    errorDialog: false,
    errorList: [],
    updatedState: false,
    sendMailDialog: false,
    sendChangedInfo: false,
    rules: {
      required: value => !!value || "Pflichtfeld"
    },
    publicComment: "",
    availableSelections: [
      { text: "Meldung abgegeben", value: "created" },
      { text: "Meldung in Bearbeitung", value: "in progress" },
      { text: "Meldung abgeschlossen (erfolgreich)", value: "successfull" },
      { text: "Meldung abgeschlossen (nicht erfolgreich)", value: "failed" }
    ]
  }),
  computed: {
    pictureUrl() {
      return this.defect?.picture?.[0]?.url ?? undefined;
    },
    geoCoordinates() {
      if (!this.defect?.location?.geo?.coordinates?.length) {
        return { lat: 0, lng: 0 };
      }
      return {
        lat: this.defect.location.geo.coordinates[0],
        lng: this.defect.location.geo.coordinates[1]
      };
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    logUrl() {
      return `${env.kis_api_client_url}log/${this.defect._id}`;
    }
  },
  async mounted() {
    await this.fetchUpdatedByUser(this.defect?.updatedBy);
  },
  watch: {
    async "defect.updatedBy"(updatedBy) {
      await this.fetchUpdatedByUser(updatedBy);
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    checkValid() {
      this.isValid = this.$refs.defectEditForm.validate();
      return this.isValid;
    },
    async fetchUpdatedByUser(updatedBy) {
      if (!updatedBy) {
        this.user = null;
        return;
      }

      try {
        this.user = await getUserById(updatedBy);
      } catch (e) {
        this.user = null;
        await this.$store.dispatch("createError", e);
      }
    },
    async closeMailPopup(sendMail = false) {
      this.sendChangedInfo = sendMail;
      this.sendMailDialog = false;
      this.publicComment = this.publicComment.trim();

      if (sendMail && this.publicComment) {
        if (!this.defect.comments) {
          this.defect.comments = [];
        }
        this.defect.comments.push({
          visibility: "public",
          text: this.publicComment
        });
        this.publicComment = "";
      }

      await this.save();
    },
    async checkStateChange(close = false) {
      this.checkValid();
      if (this.updatedState && this.isValid) {
        this.sendMailDialog = true;
      } else if (this.isValid) {
        await this.save(close);
      }
    },
    async save(close = false) {
      this.checkValid();

      if (this.updatedState && this.isValid) {
        this.defect.preventUpdateMail = !this.sendChangedInfo;
      }

      if (this.isValid) this.$emit("saveDefect", close);
      this.updatedState = false;
    },
    updateCategory(category) {
      this.defect.category = category;
    },
    updatePersons(persons) {
      this.defect.responsiblePersons = persons;
    },
    getNiceDateTime(value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
    async getLogs() {
      try {
        const headers = getTokenHeader();
        const response = await axios.get(
          `${env.kis_api_client_url}log/${this.defect._id}`,
          {
            headers
          }
        );
        this.logs = response?.data ?? [];
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    }
  }
};
